module.exports = __webpack_public_path__ + "static/media/industry-solid.4fcdbcb8.svg";